<template>
    <div class="container">
        <div class="pt-3 p-sm-3" v-cloak>
            <h3 class="text-uppercase mt-4">Received Invites</h3>
            <hr class="bar my-3" />

            <div v-for="(invite, index) in invites" class="card my-3">
                <div class="card-body">
                    <h4>
                        <b>{{ invite.inviter }}</b> invited you to join
                        <b>{{ invite.inviter_company }}</b
                        >.
                    </h4>
                    <p class="text-muted">
                        Sent on {{ moment(invite.created_at).format("MM/DD/YYYY") }}
                    </p>

                    <div class="d-flex w-100 justify-content-around mt-5">
                        <a
                            @click="declineInvite(invite.code)"
                            class="btn btn-danger text-white text-uppercase"
                            >Decline</a
                        >
                        <a
                            @click="acceptInvite(invite.code)"
                            class="btn btn-success text-white text-uppercase"
                            >Accept</a
                        >
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import GoLotusSideMenu from "./GoLotusSideMenu";
import { sideMenuItems } from "../plugins/sideMenuItems";

export default {
    name: "AcceptInvite",
    props: ["user"],
    mixins: [sideMenuItems],
    components: {
        GoLotusSideMenu,
    },
    data() {
        return {
            invites: [],
        };
    },
    created() {
        this.getInvites();
    },
    methods: {
        getInvites() {
            axios
                .get("api/invites")
                .then(r => {
                    this.invites = r.data.data;
                })
                .catch(e => {
                    console.error(e);
                });
        },

        clearInvite(index) {
            this.invites.splice(index, 1);
            if (!this.invites.length) {
                window.location = "/account";
            }
        },

        acceptInvite(code, index) {
            axios
                .post("api/invites", { code })
                .then(() => {
                    this.clearInvite(index);
                })
                .catch(e => {
                    console.error(e);
                });
        },

        declineInvite(code, index) {
            axios
                .delete(`api/invites/${code}`)
                .then(() => {
                    this.clearInvite(index);
                })
                .catch(e => {
                    console.error(e);
                });
        },
    },
};
</script>

<style scoped></style>
